<template>
    <div>
        <mark
                style="position:fixed;top:0;bottom:0;left:0;right:0;background:rgba(0,0,0,0);z-index:999;"
                v-show="showSeason"
                @click.stop="showSeason=false"
        ></mark>
        <el-input placeholder="请选择周" v-model="showValue" style="width:245px;" @focus="showSeason=true">
            <i slot="prefix" class="el-input__icon el-icon-date"></i>
        </el-input>
        <el-card
                class="box-card"
                style="width:322px;padding: 0 3px 20px;margin-top:10px;position:absolute;bottom:40px;z-index:9999"
                v-show="showSeason"
        >
            <div slot="header" class="clearfix" style="text-align:center;padding:0">
                <button
                        type="button"
                        aria-label="上个月"
                        class="el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left"
                        @click="prev"
                ></button>
                <span role="button" class="el-date-picker__header-label">{{year}}年{{month}}月</span>
                <button
                        type="button"
                        aria-label="下个月"
                        @click="next"
                        class="el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right"
                ></button>
            </div>
            <div class="text item" style="text-align:center;">
                <el-button
                        type="text"
                        size="medium"
                        style="width:50%;color: #606266;float:left;margin:0"
                        @click="selectSeason(index)"
                        v-for="(item,index) in weekArray "
                        :key="index"
                >{{item}}</el-button>

            </div>
        </el-card>
    </div>
</template>
<script>
    /**
     * @file:  View 组件 周选择控件
     */
    export default {
        props: {

            getValue: {
                default: () => {},
                type: Function
            },
            defaultValue: {
                default: '',
                type: String
            }
        },
        data() {
            return {
                showSeason: false,
                season: '',
                year: new Date().getFullYear(),
                month: new Date().getMonth()+1,
                showValue: '',
                num:0,
                weekArray:[]
            }
        },
        created() {
            if (this.defaultValue) {

                let value = this.defaultValue
                console.log(value)
                let arr = value.split('W')
                this.year = arr[0].slice(0, 4)
                this.month = arr[0].slice(4)
                this.showValue = `${this.year}年${this.month}月第${arr[1]}周`
                var last=new Date(this.year, this.month,0);
                this.getMonthWeek(this.year, this.month, last.getDate())

            }else{
                var today=new Date();
                var last=new Date(today.getFullYear(), today.getMonth()+1,0);//获取当前bai月最后du一天时间
                var y = last.getFullYear();
                var m = last.getMonth()+1;
                var d = last.getDate();
                this.getMonthWeek(y, m, d)
            }
        },

        methods: {
            one() {
                this.showSeason = false
            },
            prev() {
                if(this.month * 1 == 1){
                    this.year = this.year * 1 - 1
                    this.month = 12
                }else{
                    this.month = this.month * 1 - 1
                }
                var last=new Date(this.year, this.month,0);
                this.getMonthWeek(this.year ,this.month , last.getDate())


            },
            getMonthWeek(a,b,c){
                var date = new Date(a, parseInt(b) - 1, c), w = date.getDay(), d = date.getDate();
                this.num = Math.ceil(
                    (d + 6 - w) / 7
                );
                if(this.num == 4){
                    this.weekArray=['第一周','第二周','第三周','第四周']
                }else if(this.num == 5){
                    this.weekArray=['第一周','第二周','第三周','第四周','第五周']
                }else if(this.num == 6){
                    this.weekArray=['第一周','第二周','第三周','第四周','第五周','第六周']
                }

            },
            next() {
                if(this.month * 1 == 12){
                    this.year = this.year * 1 + 1
                    this.month = 1
                }else{
                    this.month = this.month * 1 + 1
                }
                var last=new Date(this.year, this.month,0);
                this.getMonthWeek(this.year ,this.month , last.getDate())
            },
            selectSeason(i) {
                let that = this
                that.season = i + 1
                that.showSeason = false
                this.showValue = `${this.year}年${this.month}月第${this.season}周`
                that.getValue(that.year,this.month,this.season)
                console.log(that.year,this.month,this.season)
                this.$emit('week-event',`${this.year}${this.month}W${i+1}`)


            }
        }
    }
</script>
<style>
    .box-card .el-card__header{
        padding: 18px 20px!important;
        padding-bottom:0!important;
    }
</style>


// WEBPACK FOOTER //
// src/components/monthComponent.vue